import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import ProgramViewList from 'features/Program';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function ProgramViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="program">
            <ProgramViewList />
          </Can>
          <Can not do="read" on="program">
            <h4 className="text-red-500">{t('permission.forbid.read.programList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default ProgramViewListPage;
